











import { Component, Vue } from "vue-property-decorator";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";
import {
  USER_ONE_DATA,
  UserData,
  UserOneVariables
} from "@/graphql/query/user/one";

@Component({
  components: {
    AuthTab
  },
  apollo: {
    user: {
      query: USER_ONE_DATA,
      variables(): UserOneVariables {
        return {
          userId: this.$apollo.vm.$route.params.userId
        };
      }
    }
  }
})
export default class TabFrame extends Vue {
  user: UserData | null = null;
  tabItems: AuthTabItem[] = [
    {
      name: "user-details",
      title: "ユーザー情報",
      scopes: ["company.management"]
    }
  ];
}
